<div class="truncate">
  <span class="text-xl font-semibold tracking-tight leading-tight truncate"
        [class.mt-2.5]="searchService.count() > 0">
    {{ title }}
  </span>
  @if(searchService.count() > 0) {
  <app-search-count [searchService]="searchService" class="truncate"></app-search-count>
  }
</div>
